import { Action } from 'redux';
import { MonthlyBreakdownReport } from 'model/BookingsMonthlyBreakdownReport';

export const MONTHLY_BREAKDOWN_REPORT_GET_START = 'MONTHLY_BREAKDOWN_REPORT_GET_START';
export const MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS = 'MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS';
export const MONTHLY_BREAKDOWN_REPORT_GET_ERROR = 'MONTHLY_BREAKDOWN_REPORT_GET_ERROR';

type MonthlyBreakdownReportGetStartAction = Action<typeof MONTHLY_BREAKDOWN_REPORT_GET_START>;

interface MonthlyBreakdownReportGetSuccessAction extends Action<typeof MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS> {
    payload: {
        report: MonthlyBreakdownReport;
    };
}

type MonthlyBreakdownReportGetErrorAction = Action<typeof MONTHLY_BREAKDOWN_REPORT_GET_ERROR>;

export type MonthlyBreakdownReportAction =
    | MonthlyBreakdownReportGetStartAction
    | MonthlyBreakdownReportGetSuccessAction
    | MonthlyBreakdownReportGetErrorAction;
